import { useEffect, useState } from "react";

// browser API methods
const apiMap = [
  [
    "requestFullscreen",
    "exitFullscreen",
    "fullscreenElement",
    "fullscreenEnabled",
    "fullscreenchange",
    "fullscreenerror",
  ],
  // WebKit
  [
    "webkitRequestFullscreen",
    "webkitExitFullscreen",
    "webkitFullscreenElement",
    "webkitFullscreenEnabled",
    "webkitfullscreenchange",
    "webkitfullscreenerror",
  ],
  // Old WebKit (Safari 5.1)
  [
    "webkitRequestFullScreen",
    "webkitCancelFullScreen",
    "webkitCurrentFullScreenElement",
    "webkitCancelFullScreen",
    "webkitfullscreenchange",
    "webkitfullscreenerror",
  ],
  // Mozilla
  [
    "mozRequestFullScreen",
    "mozCancelFullScreen",
    "mozFullScreenElement",
    "mozFullScreenEnabled",
    "mozfullscreenchange",
    "mozfullscreenerror",
  ],
  // Microsoft
  [
    "msRequestFullscreen",
    "msExitFullscreen",
    "msFullscreenElement",
    "msFullscreenEnabled",
    "MSFullscreenChange",
    "MSFullscreenError",
  ],
];

export function useFullscreenApi() {
  const [fullscreenAPI, setFullscreenAPI] = useState({});
  useEffect(() => {
    const specApi = apiMap[0];
    let browserApi;

    // determine the supported set of functions
    for (let i = 0; i < apiMap.length; i++) {
      // check for exitFullscreen function
      if (apiMap[i][1] in document) {
        browserApi = apiMap[i];
        break;
      }
    }

    // map the browser API names to the spec API names
    if (browserApi) {
      const api = {};
      for (let i = 0; i < browserApi.length; i++) {
        api[specApi[i]] = browserApi[i];
      }
      setFullscreenAPI(api);
    }
  }, []);

  return fullscreenAPI;
}
